import { displayThresholds, displayValues } from '@/metrics/constants'

const timeRangeDaysMap = {
  week: 7,
  month: 30,
  year: 365,
}

const getDisplayByDayCount = dayCount => {
  if (dayCount >= displayThresholds.quarterlyMin) return displayValues.quarterly
  if (dayCount >= displayThresholds.monthlyMin) return displayValues.monthly
  if (dayCount >= displayThresholds.weeklyMin) return displayValues.weekly
  return displayValues.daily
}

const getDayCountForCustomRange = (startDate, endDate) => {
  if (!startDate || !endDate) return 0

  const start = new Date(startDate)
  const end = new Date(endDate)
  const diffTime = Math.abs(end - start)
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}

export const getDefaultDisplayByTimeRange = (timeRange, startDate, endDate) => {
  if (timeRange === 'custom') {
    const dayCount = getDayCountForCustomRange(startDate, endDate)
    if (dayCount === 0) return displayValues.daily
    return getDisplayByDayCount(dayCount)
  }

  const dayCount = timeRangeDaysMap[timeRange]
  if (!dayCount) return displayValues.daily
  return getDisplayByDayCount(dayCount)
}
